import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { APP_ENVIRONMENT } from '@qtek/core/api-core';
import { Environment, HTTP_BASE_URL } from '@qtek/shared/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ServerHealthResponse, ServerStatus, ServerTarget } from '../models';

/**
 * Reads the build and liveness of the REST and the WS host. v2 never ported the
 * v1 `ping` endpoint, so both come from the plain `/actuator/health` on each
 * host, where the shared `ServerStatusService` indicator publishes them.
 */
@Injectable({
  providedIn: 'root',
})
export class ServerStatusService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly baseUrl: string = inject(HTTP_BASE_URL);
  private readonly environment: Environment = inject(APP_ENVIRONMENT);

  getServerStatus(target: ServerTarget): Observable<ServerStatus> {
    const headers = new HttpHeaders({
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      Pragma: 'no-cache',
      Expires: '0',
      'ngsw-bypass': 'true',
    });

    return this.http
      .get<ServerHealthResponse>(`${this.getBaseUrl(target)}/actuator/health`, {
        headers,
      })
      .pipe(
        map(health => ({
          status: health.status,
          version:
            health.components?.serverStatusService?.details?.version ?? null,
          runmode:
            health.components?.serverStatusService?.details?.runmode ?? null,
        }))
      );
  }

  private getBaseUrl(target: ServerTarget): string {
    if (target === 'http') {
      return this.baseUrl;
    }

    const protocol =
      this.environment.websocket.protocol === 'wss' ? 'https' : 'http';

    return `${protocol}://${this.environment.websocket.hostname}`;
  }
}
